import { FormattedMessage } from 'react-intl';

import { CryptoWalletIcon } from '#src/components/paymentMethods/Icon/CryptoWalletIcon/index.tsx';
import { SorareWallet } from '#src/components/paymentMethods/SorareWallet/index.tsx';
import { UserBalance } from '#src/components/wallet/UserBalance/index.tsx';
import { useCryptoBalance } from '#src/hooks/useCryptoBalance.ts';
import { payment } from '#src/lib/glossary.ts';

type Props = {
  withoutBalance?: boolean;
};

export const CryptoWallet = ({ withoutBalance }: Props) => {
  const { cryptocurrencySymbol } = useCryptoBalance();
  return (
    <SorareWallet
      icon={<CryptoWalletIcon />}
      label={
        <FormattedMessage
          {...payment.sorareCryptoWallet}
          values={{ cryptocurrencySymbol }}
        />
      }
      balance={<UserBalance inline disableToggle />}
      withoutBalance={withoutBalance}
    />
  );
};
